export enum SectionType {
	HOME = 'home',
	WORK = 'work',
	PROJECT = 'project',
	ABOUT = 'about',
	MENU = 'menu'
}
export enum AboutSectionType {
	HOME = 'home',
	INFO = 'info',
	STUDIO = 'studio',
	CONTACT = 'contact',
	WHAT_WE_DO = 'what-we-do',
	OUR_PROCESS = 'our-process',
	JOBS = 'jobs',
	WORK = 'work'
}
export enum DepartmentType {
	SCREENS = 'screens',
	SPACES = 'spaces',
	SYSTEMS = 'systems'
}
export enum ViewType {
	HOME = 'home',
	SCREENS = 'screens',
	SPACES = 'spaces',
	PROJECT = 'project',
	INFO = 'info',
	ALL = 'all'
}

export enum DirectionalKeyType {
	UP = 'up',
	DOWN = 'down',
	PAGE_UP = 'pageup',
	PAGE_DOWN = 'pagedown',
	LEFT = 'left',
	RIGHT = 'right'
}
export enum MenuStateType {
	OPEN = 'open',
	CLOSED = 'closed'
}

export enum ProjectSlugType {
	MARKET_MASTERS = 'market-masters',
	MARCH_FOR_GIANTS = 'march-for-giants',
	TOY_TOWN = 'toy-town',
	TOTAL_DARKNESS = 'total-darkness'
}

export enum PixiResourceType {
	INIT = 'init',
	BACKGROUND = 'background',

	//OLD--------------------------------
	BACKGROUNDS = 'backgrounds',
	HOME_PARTCILES = 'home-partciles',
	LOGO_MORPH = 'logo-morph',
	WORK_PARTICLES = 'work-particles',
	WORK_PARTICLES_32 = 'work-particles-32',
	WORK_BACKGROUNDS_SCREEN = 'work-background-screens',
	WORK_BACKGROUNDS_SPACES = 'work-background-spaces',
	MOTH = 'moth'
}

export enum TimelineItemKind {
	STANDARD = 'standard',
	MASKED_TEXT = 'masked-text',
	FIELD = 'field',
	RELATIVE_CHILDREN = 'relative-children'
}

export enum UIThemeColourType {
	LIGHT = 'light',
	DARK = 'dark'
}

export enum ScrollerType {
	NATIVE = 'native', //Ipad / Android Tablet / MAC - just use standard scroll to make use hardware (Effects + vertical dragging hook into )
	NATIVE_CUSTOM = 'native_custom', //Windows remove add inerina type scrolling
	CUSTOM = 'custom' //Android phone / iOS not tablet
}
